module.exports = __webpack_public_path__ + "img/soldering_irons_small.9885fd11.jpg";